import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03257ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-button-c" }, [
  /*#__PURE__*/_createElementVNode("span", null, "修改退款申请")
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { useRoute, useRouter } from "vue-router"
import { ref } from "vue"
interface Props {
  orderid: number
  goodsid: number
  orderno: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PostButton',
  props: {
    orderid: { default: 0 },
    goodsid: { default: 0 },
    orderno: { default: "" }
  },
  setup(__props: any) {

const { orderid, goodsid, orderno } = __props as { orderid: number, goodsid: number, orderno: string };

let router = useRouter()

let goto = () => {
  router.push({ name: "postsale", params: { orderid, goodsid, orderno } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "title-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goto)()))
  }, _hoisted_2))
}
}

})